import { useEffect, useState } from "react";
import { Avatar, Box } from "@mui/material";
import { DataGridTable } from "../DataGridTable/DataGridTable";
import { ColumnText } from "../DataGridTable/ColumnText";
import { ColumnButton } from "../DataGridTable/ColumnButton";
import { HeaderGridTable } from "../DataGridTable/HeaderGridTable";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import ModalInfo from "./Modal/ModalInfo";
import {
  Banner,
  resetFilters,
  setDialog,
  setFilters,
} from "../../app/slices/bannerSlice";
import { useDispatch, useSelector } from "react-redux";
import { useDebounce } from "use-debounce";
import AlertDialog from "../AlertDialog";

export const Tabel = () => {
  const dispatch = useDispatch();
  const {
    banner: { data, filters, loading, total },
    manageBanner: { dialog },
  } = useSelector((state) => state.banner);
  const [search, setSearch] = useState(null);
  const [debouncedSearch] = useDebounce(search, 600);
  const columns = [
    {
      field: "title",
      headerName: "Title",
      headerClassName: "employer-grid--header",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <Box
            display={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <a href={params.row?.attachment} target="_blank">
              <Avatar
                sx={{
                  width: 60,
                  maxHeight: 60,
                  borderRadius: 1,
                  border: "2px solid #e74c3c",
                }}
                alt="Remy Sharp"
                src={params.row?.attachment}
              />
            </a>
            &nbsp; &nbsp;
            <ColumnText
              text={params.row?.title}
              variant="subtitle1"
              fontWeight="bold"
            />
          </Box>
        );
      },
    },
    {
      field: "description",
      headerName: "Description",
      headerClassName: "employer-grid--header",
      flex: 1,
      minWidth: 250,
      sortable: false,
      renderCell: (params) => {
        return (
          <Box display={"flex"} alignItems={"center"} gap={2}>
            <ColumnText
              text={params.row?.description}
              variant="subtitle2"
              fontWeight="bold"
            />
          </Box>
        );
      },
    },
    {
      field: "url",
      headerName: "URL",
      headerClassName: "employer-grid--header",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <Box display={"flex"} alignItems={"center"} gap={2}>
            <ColumnText
              text={params.row?.url}
              variant="subtitle2"
              fontWeight="bold"
            />
          </Box>
        );
      },
    },
    {
      field: "operations",
      headerName: "Operations",
      flex: 1,
      minWidth: 120,
      headerClassName: "employer-grid--header",
      sortable: false,
      renderCell: (params) => {
        const [showConfirmDeleteModal, setShowConfirmDeleteModal] =
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useState(false);
        return (
          <Box display={"flex"} alignItems={"center"} gap={2}>
            <ColumnButton
              onClick={() =>
                dispatch(
                  setDialog({
                    id: params.row.id,
                    title: params.row.title,
                    url: params.row.url,
                    description: params.row.description,
                    attachment: params.row.attachment,
                  })
                )
              }
              type={"edit"}
            />
            <ColumnButton
              onClick={() => setShowConfirmDeleteModal(true)}
              type={"delete"}
            />
            <AlertDialog
              open={showConfirmDeleteModal}
              action={() => dispatch(Banner.deleteBanner(params.row.id))}
              handleClose={() => setShowConfirmDeleteModal(false)}
              title="Delete Banner"
              message={`Are you sure you want to delete ${params.row?.title}`}
            />
          </Box>
        );
      },
    },
  ];

  const fetchData = () => {
    dispatch(Banner.index());
  };

  useEffect(() => {
    if (debouncedSearch !== null) {
      dispatch(setFilters({ search: debouncedSearch }));
    }
  }, [debouncedSearch]);

  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    return () => {
      dispatch(resetFilters());
    };
  }, []);
  return (
    <>
      <Box m={2}>
        <HeaderGridTable
          title="Banners"
          icon={<HomeWorkIcon size={25} color={"primary"} />}
          btn={"Add Banner"}
          fetchData={fetchData}
          handleSearch={(e) => {
            setSearch(e.target.value);
          }}
          handleAdd={() => dispatch(setDialog())}
        />
        <Box mt={2}>
          <DataGridTable
            rowCount={total}
            rows={data}
            loading={loading}
            page={filters.page}
            columns={columns}
            pageSize={filters.take}
            onPageChange={(newPage) => {
              dispatch(
                setFilters({
                  skip: newPage * filters.take,
                  page: newPage,
                })
              );
            }}
            onPageSizeChange={(newPageSize) => {
              dispatch(
                setFilters({
                  take: newPageSize,
                })
              );
              if (filters.skip === 0) {
                dispatch(Banner.index());
              } else {
                dispatch(
                  setFilters({
                    skip: 0,
                    page: 0,
                  })
                );
              }
            }}
          />
        </Box>
        {/* Modal */}
        {dialog && <ModalInfo />}
      </Box>
    </>
  );
};

export default Tabel;
